/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_Hero_Imagealt1Inputs */

const ja_playdata_home_hero_imagealt1 = /** @type {(inputs: Playdata_Home_Hero_Imagealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eスポーツ大会配信におけるミラー配信トレンドのグラフ`)
};

const en_playdata_home_hero_imagealt1 = /** @type {(inputs: Playdata_Home_Hero_Imagealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chart of mirror-broadcast trends across esports events`)
};

/**
* | output |
* | --- |
* | "Chart of mirror-broadcast trends across esports events" |
*
* @param {Playdata_Home_Hero_Imagealt1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_home_hero_imagealt1 = /** @type {((inputs?: Playdata_Home_Hero_Imagealt1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_Hero_Imagealt1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_hero_imagealt1(inputs)
	return en_playdata_home_hero_imagealt1(inputs)
});
export { playdata_home_hero_imagealt1 as "playdata_home_hero_imageAlt" }